import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import BankAccountComponent from '../components/bank-account.component';
import { bankAccounts } from '../../../../../../redux/fms/bank-accounts/action';
import { selectBankAccountsQueryItems } from '../../../../../../redux/fms/bank-accounts/selector';

const ManagementBankAccount = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const bankAccountsQueryData = useSelector(selectBankAccountsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedBankAccounts, setSelectedBankAccounts] = useState<any>([])

  const fetchBankAccountsQueryById = () => {
    dispatch(bankAccounts.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/bank-accounts/query`,
      entity: 'bankAccounts',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBankAccounts({ ...selectedBankAccounts, [field]: event });
  }

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchBankAccountsQueryById()
    }
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedBankAccounts(bankAccountsQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(bankAccounts.resetAction({ actionType: 'update' }))
      await dispatch(bankAccounts.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/bank-accounts`,
        entity: 'bankAccounts',
        jsonData:
        {
          Records: [
            {
              ...selectedBankAccounts
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(bankAccounts.resetAction({ actionType: 'create' }))
      await dispatch(bankAccounts.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/bank-accounts`,
        entity: 'bankAccounts',
        jsonData:
        {
          Records: [
            {
              ...selectedBankAccounts
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/bank-accounts')
  }

  return (
    <>
      {bankAccountsQueryData?.isLoading ? <PageLoader /> :
        <BankAccountComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedBankAccounts={selectedBankAccounts}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
        />
      }
    </>
  )
}

export default ManagementBankAccount;